import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { getActiveBrandId, getActiveStage, getAppTitle } from './config/brands'

// 빌드한 브랜드·스테이지(src/config/brands.ts) — 탭 제목으로 real/beta를 구분하고, 화면별 분기가 필요하면 data 속성을 쓴다
document.title = getAppTitle()
document.documentElement.setAttribute('data-brand', getActiveBrandId())
document.documentElement.setAttribute('data-stage', getActiveStage())

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
